// extracted by mini-css-extract-plugin
export default {"imageContainer":"i3-z","summaryPar":"j3-z","ratingCategories":"k3-z","reviewerInfo":"l3-z","reviewTypes":"m3-z","expanded":"n3-z"};